import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Grid } from "@mui/material";
import styled, { keyframes } from "styled-components";
import { Card as BootstrapCard } from "reactstrap";
import PincodeConfig from "../Picklist/PincodeConfig";
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import PartyTypePicklist from "../Picklist/partyType";
import BoardMaster from "../Picklist/boardMaster";
import ClassMaster from "../Picklist/classMaster";
import CollectionType from "../Picklist/collectionType";
import ContactPersonRole from "../Picklist/contactPersonRole";
import FeedbackMaster from "../Picklist/feedbackMaster";
import GivenType from "../Picklist/givenType";
import GradeMaster from "../Picklist/gradeMaster";
import MediumMaster from "../Picklist/mediumMaster";
import NextType from "../Picklist/nextStep";
import PaymentType from "../Picklist/paymentType";
import RecieveCollection from "../Picklist/recieveCollection";
import RouteVisitType from "../Picklist/routeVisitType";
import StatusType from "../Picklist/statusType";
import SubjectMaster from "../Picklist/subjectMaster";
import VehicleType from "../Picklist/vehicleType";
import WorkDone from "../Picklist/workDone";
import ExpensePurpose from "./../Picklist/expensePurpose";
import ExpenseType from "../Picklist/expenseType";
import DeliveryStatus from "../Picklist/deliveryStatus";
import SchoolCategory from "../Picklist/schoolCategory";
import VisitOutcome from "../Picklist/visitOutcome";
import ReturnReason from "../Picklist/returnReason";
import ProductGroup from "../Picklist/productGroup";
import MittplusProductGroup from "../Picklist/mittplusProductGroup";
import SeriesMaster from "../Picklist/seriesMaster";
import AddOnProducts from "../Picklist/AddOnProducts";
import RemarkComponent from "../Picklist/RemarkComponent";
import WareHouseComponent from "../Picklist/WareHouseComponent";
import ClusterComponent from "../Picklist/ClusterComponent";
import NotificationEmail from "../Picklist/NotificationEmail";
import CustomerType from "../Picklist/CustomerType";
import InputSource from "../Picklist/InputSource";
import SchoolType from "../Picklist/SchoolType";
import Reason from "../Picklist/Reason";
import AttendanceConfig from "../Picklist/AttendanceConfig";
import Cities from "../Picklist/Cities";
import ExpenseSubType from "../Picklist/ExpenseSubType";
import SessionManagement from "../Picklist/SessionManagement";
import OlympiadRegistrationType from "../Picklist/OlympiadRegistrationType";
// import OlympiadSubject from "../Picklist/OlympiadSubject";
// import OlympiadClass from "../Picklist/OlympiadClass";
// import OlympiadExamType from "../Picklist/OlympiadExamType";
// import OlympiadRound from "../Picklist/OlympiadRound";
// import OlympiadAwardCategory from "../Picklist/OlympiadAwardCategory";
// import OlympiadResultStatus from "../Picklist/OlympiadResultStatus";
// import OlympiadParticipationMode from "../Picklist/OlympiadParticipationMode";
// import OlympiadCertificateType from "../Picklist/OlympiadCertificateType";
import OlympiadPaymentMode from "../Picklist/OlympiadPaymentMode";
import OlympiadMedium from "../Picklist/OlympiadMedium";
import OlympiadSubject from "../Picklist/OlympiadSubject";
import OlympiadClass from "../Picklist/OlympiadClass";
import OlympiadDate from "../Picklist/OlympiadDate";
import OlympiadShipmentItems from "../Picklist/OlympiadShipmentItems";
import OlympiadClassSubjectMapping from "../Picklist/OlympiadClassSubjectMapping";
// import OlympiadDisqualificationReason from "../Picklist/OlympiadDisqualificationReason";

// ── Animations ────────────────────────────────────────────────────────────────
const fadeSlideIn = keyframes`
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
`;

// ── Styled Components ─────────────────────────────────────────────────────────
const PageContainer = styled.div`
  height: ${window.innerWidth < 900 ? "auto" : "calc(100vh - 105px)"};
  width: 100%;
  background-color: #f5f6fa;
  padding: 16px 20px;
  margin-top: 20px;
  overflow-y: auto;
  ${window.innerWidth < 900 && "position: relative"}
`;

const ModeToggleBar = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 5px;
  width: fit-content;
  margin-bottom: 22px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.07);
`;

const ModeBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 8px 20px;
  border-radius: 7px;
  border: none;
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.22s ease;
  letter-spacing: 0.3px;
  background: ${({ active, modekey }) => {
    if (!active) return "transparent";
    return modekey === "olympiad"
      ? "linear-gradient(135deg, #7c3aed, #a855f7)"
      : "linear-gradient(135deg, #1d6fce, #3b8ef0)";
  }};
  color: ${({ active }) => (active ? "#fff" : "#666")};
  box-shadow: ${({ active, modekey }) =>
    active
      ? modekey === "olympiad"
        ? "0 2px 8px rgba(124,58,237,0.35)"
        : "0 2px 8px rgba(29,111,206,0.3)"
      : "none"};

  &:hover {
    background: ${({ active, modekey }) =>
      active
        ? undefined
        : modekey === "olympiad"
        ? "rgba(124,58,237,0.08)"
        : "rgba(29,111,206,0.08)"};
    color: ${({ active, modekey }) =>
      active ? "#fff" : modekey === "olympiad" ? "#7c3aed" : "#1d6fce"};
  }
`;

const ModeDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ modekey, active }) =>
    active ? "#fff" : modekey === "olympiad" ? "#a855f7" : "#3b8ef0"};
  display: inline-block;
  flex-shrink: 0;
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  margin-top: 6px;
`;

const SectionLabel = styled.span`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: ${({ olympiad }) => (olympiad ? "#7c3aed" : "#1d6fce")};
  background: ${({ olympiad }) =>
    olympiad ? "rgba(124,58,237,0.08)" : "rgba(29,111,206,0.08)"};
  padding: 3px 10px;
  border-radius: 4px;
  white-space: nowrap;
`;

const SectionLine = styled.div`
  flex: 1;
  height: 1.5px;
  background: ${({ olympiad }) =>
    olympiad
      ? "linear-gradient(to right, rgba(124,58,237,0.3), transparent)"
      : "linear-gradient(to right, rgba(29,111,206,0.3), transparent)"};
  border-radius: 2px;
`;

const HoverCard = styled(BootstrapCard)`
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease, border-color 0.2s ease;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.07);
  width: 100%;
  max-width: 300px;
  border: 1.5px solid #e8eaf0 !important;
  border-radius: 8px !important;
  background: #fff;

  &:hover {
    transform: translateY(-3px) scale(1.02);
    box-shadow: ${({ olympiad }) =>
      olympiad
        ? "0px 6px 18px rgba(124,58,237,0.18)"
        : "0px 6px 18px rgba(29,111,206,0.18)"};
    border-color: ${({ olympiad }) =>
      olympiad ? "#a855f7" : "#3b8ef0"} !important;
    background: ${({ olympiad }) =>
      olympiad
        ? "linear-gradient(135deg, #faf5ff, #f3e8ff)"
        : "linear-gradient(135deg, #eff6ff, #dbeafe)"} !important;
  }
`;

const CardInner = styled.div`
  padding: 11px 14px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CardIcon = styled.span`
  font-size: 16px;
  flex-shrink: 0;
`;

const AnimatedSection = styled.div`
  animation: ${fadeSlideIn} 0.25s ease both;
`;

const GridWrapper = styled.div`
  margin-bottom: 24px;
`;

const ICON_MAP = {
  // GLOBAL
  "Areas":                        "📍",
  "Given Type":                   "🔖",
  "Payment Type":                 "💰",
  "Return Reason":                "↩️",
  "Series":                       "📦",
  "Notification Email":           "📧",
  "Cities":                       "🌆",
  "Attendance Configuration":     "🗓️",
  "Pincode":                      "📮",
  "Session Management":           "🔐",

  // OLYMPIAD
  "Registration Type":            "📋",
  "Olympiad Subject":             "📚",
  "Olympiad Class":               "🏫",
  "Olympiad Medium":              "🗣️",
  "Olympiad Date":                "🗓️",
  "Olympiad Shipment Items":      "🚚",
  "Class Subject Mapping":        "📚",
  "Olympiad Round":               "🔄",
  "Award Category":               "🏆",
  "Result Status":                "✅",
  "Participation Mode":           "🎯",
  "Certificate Type":             "🎓",
  "Payment Mode":                 "💳",
  "Disqualification Reason":      "🚫",
  "Exam Type":                    "📝",

  // PARTY
  "School Board":                 "🏛️",
  "Class":                        "🏫",
  "Contact Person Role Type":     "👤",
  "Grade":                        "🎖️",
  "Medium":                       "🗣️",
  "Party Type":                   "🏷️",
  "School Category":              "🏷️",
  "Subject":                      "📖",
  "Customer Type":                "👥",
  "Lead Source":                  "🔍",
  "School Type":                  "🏫",

  // ROUTE
  "Route Visit Type":             "🗺️",

  // PRODUCT
  "Mittplus Product Groups":      "📦",
  "Product Groups":               "🗂️",
  "Add On Products":              "➕",

  // COLLECTION
  "Collection Type":              "💼",
  "Receive Collection Type":      "📥",

  // ORDER
  "Delivery Status":              "🚚",
  "Order Remark":                 "💬",
  "WareHouse":                    "🏭",

  // EXPENSE
  "Expense Purpose":              "🎯",
  "Expense Type":                 "🧾",
  "Expense Sub Type":             "📂",

  // VISIT
  "Feedback":                     "💬",
  "Next Step":                    "⏭️",
  "Status Type":                  "🔘",
  "Vehicle Type":                 "🚗",
  "Visit Outcomes":               "📊",
  "Work Done":                    "✔️",
  "No Interest Reason":           "❌",
  default: "⚙️",
};

// ── Route definitions ─────────────────────────────────────────────────────────
const buildRoutes = (userData) => [
  // GLOBAL
  { path: "/product/cluster",                 name: "Areas",                    component: ClusterComponent,              showIn: "global" },
  { path: "/additionalData/givenType",        name: "Given Type",               component: GivenType,                     showIn: "global" },
  { path: "/additionalData/paymentType",      name: "Payment Type",             component: PaymentType,                   showIn: "global" },
  { path: "/additionalData/returnReason",     name: "Return Reason",            component: ReturnReason,                  showIn: "global" },
  { path: "/product/seriesCategory",          name: "Series",                   component: SeriesMaster,                  showIn: "global" },
  { path: "/product/notificationEmail",       name: "Notification Email",       component: NotificationEmail,             showIn: "global" },
  { path: "/additionalData/cities",           name: "Cities",                   component: Cities,                        showIn: "global" },
  { path: "/additionalData/attendanceConfig", name: "Attendance Configuration", component: AttendanceConfig,              showIn: "global" },
  { path: "/additionalData/pincode",          name: "Pincode",                  component: PincodeConfig,                 showIn: "global" },
  ...(String(userData?.role) === "super admin"
    ? [{ path: "/session/sessionManagement",  name: "Session Management",       component: SessionManagement,             showIn: "global" }]
    : []),
  // OLYMPIAD
  { path: "/olympiad/registrationType",       name: "Registration Type",        component: OlympiadRegistrationType,      showIn: "olympiad" },
  { path: "/olympiad/subject",                name: "Olympiad Subject",         component: OlympiadSubject,               showIn: "olympiad" },
  { path: "/olympiad/class",                  name: "Olympiad Class",           component: OlympiadClass,                 showIn: "olympiad" },
  { path: "/olympiad/medium",                 name: "Olympiad Medium",          component: OlympiadMedium,                showIn: "olympiad" },
  { path: "/olympiad/date",                   name: "Olympiad Date",            component: OlympiadDate,                  showIn: "olympiad" },
  { path: "/olympiad/shipmentItem",           name: "Olympiad Shipment Items",  component: OlympiadShipmentItems,         showIn: "olympiad" },
  { path: "/olympiad/classSubjectMapping",    name: "Class Subject Mapping",    component: OlympiadClassSubjectMapping,           showIn: "olympiad" },
  // { path: "/olympiad/participationMode",      name: "Participation Mode",       component: OlympiadParticipationMode,     showIn: "olympiad" },
  // { path: "/olympiad/certificateType",        name: "Certificate Type",         component: OlympiadCertificateType,       showIn: "olympiad" },
  { path: "/olympiad/paymentMode",            name: "Payment Mode",             component: OlympiadPaymentMode,           showIn: "olympiad" },
  // { path: "/olympiad/disqualificationReason", name: "Disqualification Reason",  component: OlympiadDisqualificationReason, showIn: "olympiad" },
  // PARTY
  { path: "/additionalData/boardMaster",           name: "School Board",             component: BoardMaster,          showIn: "party" },
  { path: "/additionalData/classMaster",           name: "Class",                    component: ClassMaster,          showIn: "party" },
  { path: "/additionalData/contactPersonRoleType", name: "Contact Person Role Type", component: ContactPersonRole,    showIn: "party" },
  { path: "/additionalData/gradeMaster",           name: "Grade",                    component: GradeMaster,          showIn: "party" },
  { path: "/additionalData/mediumMaster",          name: "Medium",                   component: MediumMaster,         showIn: "party" },
  { path: "/additionalData/partyType",             name: "Party Type",               component: PartyTypePicklist,    showIn: "party" },
  { path: "/additionalData/schoolCategory",        name: "School Category",          component: SchoolCategory,       showIn: "party" },
  { path: "/additionalData/subjectMaster",         name: "Subject",                  component: SubjectMaster,        showIn: "party" },
  { path: "/additionalData/customerType",          name: "Customer Type",            component: CustomerType,         showIn: "party" },
  { path: "/additionalData/inputSource",           name: "Lead Source",              component: InputSource,          showIn: "party" },
  { path: "/additionalData/schoolType",            name: "School Type",              component: SchoolType,           showIn: "party" },
  // ROUTE
  { path: "/additionalData/routeVisitType",        name: "Route Visit Type",         component: RouteVisitType,       showIn: "route" },
  // PRODUCT
  { path: "/additionalData/mittplusProductGroups", name: "Mittplus Product Groups",  component: MittplusProductGroup, showIn: "product" },
  { path: "/additionalData/productGroups",         name: "Product Groups",           component: ProductGroup,         showIn: "product" },
  { path: "/product/addOnProducts",                name: "Add On Products",          component: AddOnProducts,        showIn: "product" },
  // COLLECTION
  { path: "/additionalData/collectionType",        name: "Collection Type",          component: CollectionType,       showIn: "collection" },
  { path: "/additionalData/recieveCollectionType", name: "Receive Collection Type",  component: RecieveCollection,    showIn: "collection" },
  // ORDER
  { path: "/additionalData/deliveryStatus",        name: "Delivery Status",          component: DeliveryStatus,       showIn: "order" },
  { path: "/product/remark",                       name: "Order Remark",             component: RemarkComponent,      showIn: "order" },
  { path: "/product/wareHouse",                    name: "WareHouse",                component: WareHouseComponent,   showIn: "order" },
  // EXPENSE
  { path: "/additionalData/expensePurpose",        name: "Expense Purpose",          component: ExpensePurpose,       showIn: "expense" },
  { path: "/additionalData/expenseType",           name: "Expense Type",             component: ExpenseSubType,       showIn: "expense" },
  { path: "/additionalData/expenseSubType",        name: "Expense Sub Type",         component: ExpenseType,          showIn: "expense" },
  // VISIT
  { path: "/additionalData/feedbackMaster",        name: "Feedback",                 component: FeedbackMaster,       showIn: "visit" },
  { path: "/additionalData/nextStep",              name: "Next Step",                component: NextType,             showIn: "visit" },
  { path: "/additionalData/statusType",            name: "Status Type",              component: StatusType,           showIn: "visit" },
  { path: "/additionalData/vehicleType",           name: "Vehicle Type",             component: VehicleType,          showIn: "visit" },
  { path: "/additionalData/visitOutcomes",         name: "Visit Outcomes",           component: VisitOutcome,         showIn: "visit" },
  { path: "/additionalData/workDone",              name: "Work Done",                component: WorkDone,             showIn: "visit" },
  { path: "/additionalData/reason",                name: "No Interest Reason",       component: Reason,               showIn: "visit" },
];

const GENERAL_SECTIONS = ["global", "route", "party", "collection", "order", "expense", "visit", "product"];

// ── Component ─────────────────────────────────────────────────────────────────
export default function AllPicklist() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState("general"); // "general" | "olympiad"
  const [userData] = useState(
    () => JSON.parse(localStorage.getItem("storedUserData")).user
  );

  const routes = buildRoutes(userData);
  const isOlympiad = mode === "olympiad";

  const renderSection = (sectionKey) => {
    const sectionRoutes = routes.filter(
      (r) => (r.showIn || r.showin)?.toLowerCase() === sectionKey.toLowerCase()
    );
    if (!sectionRoutes.length) return null;

    return (
      <GridWrapper key={sectionKey}>
        <SectionHeader>
          <SectionLabel olympiad={isOlympiad ? 1 : 0}>{sectionKey}</SectionLabel>
          <SectionLine olympiad={isOlympiad ? 1 : 0} />
        </SectionHeader>
        <Grid container spacing={1}>
          {sectionRoutes.map((route) => (
            <Grid item xs={12} sm={4} md={3} key={route.name}>
              <HoverCard
                olympiad={isOlympiad ? 1 : 0}
                onClick={() => navigate(route.path)}
              >
                <CardInner>
                  <CardIcon>{ICON_MAP[route.name] || ICON_MAP.default}</CardIcon>
                  <Typography
                    sx={{
                      fontSize: "13.5px",
                      fontWeight: "500",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      color: "inherit",
                    }}
                  >
                    {route.name}
                  </Typography>
                </CardInner>
              </HoverCard>
            </Grid>
          ))}
        </Grid>
      </GridWrapper>
    );
  };

  return (
    <PageContainer>
      {loading && <OpaqueLoading />}

      {/* ── Mode Toggle ── */}
      <ModeToggleBar>
        <ModeBtn
          active={!isOlympiad ? 1 : 0}
          modekey="general"
          onClick={() => setMode("general")}
        >
          <ModeDot modekey="general" active={!isOlympiad ? 1 : 0} />
          General Configuration
        </ModeBtn>
        {/* <ModeBtn
          active={isOlympiad ? 1 : 0}
          modekey="olympiad"
          onClick={() => setMode("olympiad")}
        >
          <ModeDot modekey="olympiad" active={isOlympiad ? 1 : 0} />
          🏅 Olympiad Configuration
        </ModeBtn> */}
      </ModeToggleBar>

      {/* ── Content ── */}
      <AnimatedSection key={mode}>
        {isOlympiad
          ? renderSection("olympiad")
          : GENERAL_SECTIONS.map(renderSection)}
      </AnimatedSection>
    </PageContainer>
  );
}